import './less/main.less';
import 'babel-polyfill';
import React from 'react';
import moment from 'moment';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import { AppContainer } from 'react-hot-loader';
import store from './store';
import routes from './routes';

const history = syncHistoryWithStore(browserHistory, store);

moment.updateLocale('en', { //@todo remove this if multilang support added to admin panel
	week: {
		dow: 1
	}
});

ReactDOM.render(
	<AppContainer>
		<Provider store={store}>
			<Router history={history} onUpdate={() => {
				window.scrollTo(0, 0);
			}}>
				{routes}
			</Router>
		</Provider>
	</AppContainer>,
	document.getElementById('app')
);

if (module.hot && process.env.NODE_ENV === 'development') {
	module.hot.accept();
}



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/main.js